export default __webpack_public_path__ + "static/media/signup.107d73d6.png";